import React from 'react';
import { AlertProvider as AlertContextProvider } from '../../contexts/AlertContext';
import AlertModal from './AlertModal';
import AlertInitializer from './AlertInitializer';

interface AlertProviderProps {
  children: React.ReactNode;
}

/**
 * AlertProvider component that wraps the application with alert context
 * and renders the AlertModal component.
 */
const AlertProvider: React.FC<AlertProviderProps> = ({ children }) => {
  return (
    <AlertContextProvider>
      <AlertInitializer />
      {children}
      <AlertModal />
    </AlertContextProvider>
  );
};

export default AlertProvider;

